/* okvella theme script: animations, cart drawer (Shopify AJAX cart), product page, delivery estimate */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfg = window.okv || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };

  /* ---------- word + scroll reveals ---------- */
  function splitWords(root) {
    $$('[data-words]', root).forEach(function (el) {
      if (el.dataset.split) return; el.dataset.split = '1'; var i = 0;
      (function walk(n) {
        Array.prototype.slice.call(n.childNodes).forEach(function (c) {
          if (c.nodeType === 3) {
            var fr = document.createDocumentFragment();
            c.textContent.split(/(\s+)/).forEach(function (t) {
              if (!t) return;
              if (/^\s+$/.test(t)) { fr.appendChild(document.createTextNode(' ')); return; }
              var s = document.createElement('span'); s.className = 'w'; s.style.setProperty('--i', i++); s.textContent = t; fr.appendChild(s);
            });
            c.parentNode.replaceChild(fr, c);
          } else if (c.nodeType === 1 && c.tagName !== 'BR') walk(c);
        });
      })(el);
      el.setAttribute('data-reveal', 'words');
    });
  }
  var io = null;
  function observeReveals(root) {
    if (RM || !('IntersectionObserver' in window)) return;
    if (!io) io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('go'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px 12% 0px' });
    $$('[data-reveal]:not(.go)', root).forEach(function (el) { io.observe(el); });
  }

  /* ---------- parallax (mouse + scroll) ---------- */
  var depthEls = [], speedEls = [], mx = 0, my = 0, tx = 0, ty = 0;
  function cacheMotion() { depthEls = $$('[data-depth]'); speedEls = $$('[data-speed]'); }
  var MOTION = false; /* mouse + scroll parallax switched off: calmer, premium, no sideways drift */
  if (MOTION && !RM) {
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'mouse') { mx = e.clientX / innerWidth - 0.5; my = e.clientY / innerHeight - 0.5; }
    }, { passive: true });
    (function tick() {
      tx += (mx - tx) * 0.07; ty += (my - ty) * 0.07;
      for (var i = 0; i < depthEls.length; i++) {
        var d = +depthEls[i].dataset.depth;
        depthEls[i].style.transform = 'translate3d(' + (tx * d).toFixed(2) + 'px,' + (ty * d).toFixed(2) + 'px,0)';
      }
      var vh = innerHeight;
      for (var j = 0; j < speedEls.length; j++) {
        var el = speedEls[j], r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue;
        var off = (r.top + r.height / 2 - vh / 2) * (+el.dataset.speed);
        el.style.transform = 'translate3d(0,' + (-off).toFixed(2) + 'px,0)';
      }
      requestAnimationFrame(tick);
    })();
  }
  window.addEventListener('scroll', function () {
    var m = $('#mini'); if (m) m.classList.toggle('on', scrollY > innerHeight * 0.7);
  }, { passive: true });

  /* ---------- carousels: arrows + mouse drag ---------- */
  var drag = null, dragMoved = false;
  document.addEventListener('pointerdown', function (e) {
    var r = e.target.closest('.rail'); if (!r || e.pointerType !== 'mouse') return;
    drag = { r: r, x: e.clientX, s: r.scrollLeft }; dragMoved = false;
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag) return; var dx = e.clientX - drag.x;
    if (Math.abs(dx) > 6) { dragMoved = true; drag.r.classList.add('dragging'); }
    if (dragMoved) drag.r.scrollLeft = drag.s - dx;
  });
  document.addEventListener('pointerup', function () { if (drag) { drag.r.classList.remove('dragging'); drag = null; } });
  document.addEventListener('click', function (e) {
    if (dragMoved && e.target.closest('.rail')) { e.preventDefault(); e.stopPropagation(); dragMoved = false; }
  }, true);

  /* ---------- delivery estimate: 2–3 days processing + 3–5 transit, 5 PM ET cutoff ---------- */
  function eta() {
    var now = new Date(), h = 12;
    try { h = parseInt(now.toLocaleString('en-US', { timeZone: 'America/New_York', hour: 'numeric', hour12: false }), 10) % 24; } catch (e) {}
    var wk = function (d) { return d.getDay() === 0 || d.getDay() === 6; };
    var s = new Date(now); if (h >= 17 || wk(s)) { do { s.setDate(s.getDate() + 1); } while (wk(s)); }
    var add = function (d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (!wk(x)) n--; } return x; };
    var f = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
    return f(add(s, 5)) + ' – ' + f(add(s, 8));
  }
  function fillEta() { $$('[data-eta]').forEach(function (el) { el.textContent = eta(); }); }

  /* ---------- cart drawer (Shopify AJAX API) ---------- */
  var cartState = null;
  function setCount(n) { $$('.cc').forEach(function (e) { e.textContent = n; }); }
  function fetchCart() { return fetch(cfg.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function renderCart(c) {
    cartState = c; setCount(c.item_count);
    var items = $('#cartitems'), foot = $('#cartfoot'); if (!items) return;
    if (!c.item_count) {
      items.innerHTML = '<div class="empty">your cart is empty<br><br><a class="btn" href="' + cfg.root + 'collections/all">shop now</a></div>';
      foot.innerHTML = ''; return;
    }
    items.innerHTML = c.items.map(function (it) {
      var img = it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy">' : '';
      var vt = it.variant_title && it.product_has_only_default_variant === false ? '<small>' + esc(it.variant_title) + '</small>' : '';
      return '<div class="ci"><div class="art" style="--tc:#FBF6ED">' + img + '</div><div class="nm"><a href="' + esc(it.url) + '">' + esc(it.product_title.replace(/^okvella\s+/i, '')) + '</a>' + vt +
        '<small>' + money(it.final_price) + ' · free shipping</small><div class="qty"><button type="button" data-q="' + esc(it.key) + '" data-n="' + (it.quantity - 1) + '" aria-label="Remove one">−</button><span>' + it.quantity +
        '</span><button type="button" data-q="' + esc(it.key) + '" data-n="' + (it.quantity + 1) + '" aria-label="Add one">+</button></div></div><b>' + money(it.final_line_price) + '</b></div>';
    }).join('');
    var up = cfg.upsell, upHtml = '';
    if (up && up.available && !c.items.some(function (it) { return it.product_id === up.id; })) {
      var uv = up.variants.filter(function (v) { return v.available; })[0];
      if (uv) {
        var uimg = up.featured_image ? '<img src="' + esc(up.featured_image) + '" alt="" loading="lazy">' : '';
        upHtml = '<div class="upsell"><div class="art" style="--tc:#FBF6ED">' + uimg + '</div><div class="t">add ' + esc(up.title.replace(/^okvella\s+/i, '')) + '<small>ships free with this order</small></div><button type="button" class="btn sm tomato" data-add="' + uv.id + '">+ ' + money(uv.price) + '</button></div>';
      }
    }
    foot.innerHTML = '<div class="freeship">✓ Free US shipping · estimated delivery ' + eta() + '</div>' + upHtml +
      '<div class="row-between"><span>subtotal</span><span>' + money(c.total_price) + '</span></div>' +
      '<form action="' + cfg.cart + '" method="post"><button class="btn tomato block" type="submit" name="checkout">checkout · ' + money(c.total_price) + '</button></form>' +
      '<p class="note">Taxes calculated at checkout · 30-day free returns · 1-year warranty</p>';
  }
  function openCart() {
    fetchCart().then(renderCart).catch(function () {});
    $('#drawer').hidden = false; $('#overlay').hidden = false; document.documentElement.style.overflow = 'hidden';
  }
  function closeCart() {
    var d = $('#drawer'); if (!d) return; d.hidden = true; $('#overlay').hidden = true; document.documentElement.style.overflow = '';
  }
  function addToCart(variantId, btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch(cfg.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +variantId, quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { openCart(); })
      .catch(function (err) { alertInline(btn, (err && (err.description || err.message)) || 'Could not add to cart.'); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }
  function changeQty(key, qty) {
    fetch(cfg.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function alertInline(btn, msg) {
    var host = btn && btn.parentElement; if (!host) return;
    var p = host.querySelector('.formnote.err'); if (!p) { p = document.createElement('p'); p.className = 'formnote err'; host.appendChild(p); }
    p.textContent = msg;
  }

  /* ---------- product page ---------- */
  function currentVariantInput() { return $('#variant-select') || $('#variant-id'); }
  function setPrice(price, was) {
    var p = $('#bbprice'), w = $('#bbwas'), a = $('#addprice'), s = $('#stickyprice');
    if (p) p.textContent = price; if (a) a.textContent = price; if (s) s.textContent = price;
    if (w) { if (was) { w.textContent = was; w.hidden = false; } else w.hidden = true; }
  }

  /* ---------- related products (loaded after page load) ---------- */
  function loadRecs() {
    $$('.product-recs[data-url]').forEach(function (el) {
      if (el.children.length) return;
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('.product-recs');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; splitWords(el); observeReveals(el); cacheMotion(); }
      }).catch(function () {});
    });
  }

  /* ---------- gallery arrows + swipe ---------- */
  function galStep(dir) {
    var bs = Array.prototype.slice.call(document.querySelectorAll('.gal .thumbs button'));
    if (!bs.length) return;
    var i = bs.findIndex(function (b) { return b.classList.contains('on'); });
    bs[(Math.max(i, 0) + dir + bs.length) % bs.length].click();
  }
  (function () {
    var m = document.querySelector('.gal .main'); if (!m) return; var x0 = null;
    m.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    m.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) galStep(dx < 0 ? 1 : -1); }, { passive: true });
  })();

  /* ---------- one delegated click handler ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var add = t.closest('[data-add]');
    if (add && add.dataset.add) { e.preventDefault(); addToCart(add.dataset.add, add); return; }
    var stickyAdd = t.closest('[data-sticky-add]');
    if (stickyAdd) { var f = $('#pform'); if (f) { if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true })); } return; }
    var q = t.closest('[data-q]'); if (q) { changeQty(q.dataset.q, +q.dataset.n); return; }
    if (t.closest('[data-cart]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('#cartclose') || t.id === 'overlay') { closeCart(); return; }
    if (t.closest('#menubtn')) { var mn = $('#mnav'); mn.hidden = false; t.closest('#menubtn').setAttribute('aria-expanded', 'true'); return; }
    if (t.closest('#mclose')) { $('#mnav').hidden = true; var mb = $('#menubtn'); if (mb) mb.setAttribute('aria-expanded', 'false'); return; }
    var ar = t.closest('[data-rail]');
    if (ar) { var r = document.getElementById(ar.dataset.rail); if (r) r.scrollBy({ left: (+ar.dataset.dir) * r.clientWidth * 0.8, behavior: RM ? 'auto' : 'smooth' }); return; }
    var ga = t.closest('[data-gal]');
    if (ga) { galStep(+ga.dataset.gal); return; }
    var th = t.closest('[data-thumb]');
    if (th) {
      var main = $('#galmain'); if (!main) return;
      main.innerHTML = '<img class="im contain" src="' + esc(th.dataset.thumb) + '" alt="' + esc(th.dataset.alt || '') + '">';
      $$('button', th.parentElement).forEach(function (b) { b.classList.toggle('on', b === th); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); var mn = $('#mnav'); if (mn) mn.hidden = true; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('span[data-add]')) { e.preventDefault(); e.target.click(); }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-offer]')) {
      var inp = $('#variant-id'); if (inp) inp.value = t.value;
      setPrice(t.dataset.price, t.dataset.was);
    }
    if (t.id === 'variant-select') {
      var o = t.options[t.selectedIndex]; setPrice(o.dataset.price, o.dataset.was);
    }
    if (t.id === 'sortby') {
      var u = new URL(location.href); u.searchParams.set('sort_by', t.value); location.href = u.toString();
    }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.getAttribute('id') !== 'pform') return;
    var inp = currentVariantInput(); if (!inp) return;
    e.preventDefault();
    addToCart(inp.value, $('#mainadd'));
  });

  /* ---------- boot ---------- */
  function boot() {
    splitWords(document); observeReveals(document); cacheMotion(); fillEta(); loadRecs();
    if (/[?&]customer_posted=true/.test(location.search) || /contact_posted=true/.test(location.search)) {
      var nl = $('#nl'); if (nl) nl.scrollIntoView({ block: 'center' });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
